import { Bike, Recycle, Sparkles, Sprout, Trash2, Zap, type LucideIcon } from 'lucide-react';

import type { SubmissionIconName } from '@/lib/types';

interface SubmissionIconProps {
  name: SubmissionIconName;
  className?: string;
  /** Pixel size — passed straight to lucide. */
  size?: number;
  strokeWidth?: number;
  'aria-hidden'?: boolean;
}

/**
 * Maps the curated `SubmissionIconName` union to a concrete lucide-react icon.
 * Exhaustive switch — adding a name to the union forces the `never` assertion
 * to fail at compile time. Mirrors components/quests/QuestIcon.tsx exactly.
 */
function pickIcon(name: SubmissionIconName): LucideIcon {
  switch (name) {
    case 'recycle':
      return Recycle;
    case 'bike':
      return Bike;
    case 'trash':
      return Trash2;
    case 'zap':
      return Zap;
    case 'sprout':
      return Sprout;
    case 'sparkles':
      return Sparkles;
    default: {
      const _exhaustive: never = name;
      return _exhaustive;
    }
  }
}

export function SubmissionIcon({
  name,
  className,
  size = 22,
  strokeWidth = 1.75,
  'aria-hidden': ariaHidden = true,
}: SubmissionIconProps) {
  const Icon = pickIcon(name);
  return <Icon size={size} strokeWidth={strokeWidth} className={className} aria-hidden={ariaHidden} />;
}

export default SubmissionIcon;
